export default __webpack_public_path__ + "static/media/cilinder.9851cb42.png";